import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})

export class ToastService {

    constructor(private toast: ToastController) { }

    async showToast(header: string, message: string, success: boolean = false, autoClose: boolean = true): Promise<null> {
        this.clearRequestToasts();

        return this.toast.create({
            header,
            message,
            position: 'top',
            color: success ? 'success' : 'danger',
            buttons: [{
                icon: 'close-circle-outline',
                role: 'cancel',
            }],
            duration: autoClose && success ? 2000 : 0
        }).then(t => t.present()).then(() => null);
    }

    async clearRequestToasts() {
        if (await this.toast.getTop()) {
            this.toast.dismiss();
        }
    }
}
